// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    0,
    0,
    0,
    0
  ],
  "2": [
    0,
    0,
    0,
    0,
    0
  ],
  "3": [
    0,
    0,
    0,
    0,
    0
  ],
  "4": [
    0,
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
